import { styled } from 'next-yak';

import {
  mediaConfinedOnly,
  mediaConfinedNavlessOnly,
  mediaSmallOrTiny,
} from '@xing-com/layout-tokens';
import { spaceXL } from '@xing-com/tokens';

export const PRODUCT_CARD_HEIGHT = '580px';

export const ProductCardContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spaceXL};
  justify-content: center;
  padding-top: ${spaceXL};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaSmallOrTiny} {
    flex-direction: column;
  }

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaSmallOrTiny}, ${mediaConfinedOnly}, ${mediaConfinedNavlessOnly} {
    & > [data-product-card='basic'] {
      display: none;
    }
  }
`;
